import { render, staticRenderFns } from "./TableauResultatsPassages.vue?vue&type=template&id=13f41e56&scoped=true"
import script from "./TableauResultatsPassages.vue?vue&type=script&lang=js"
export * from "./TableauResultatsPassages.vue?vue&type=script&lang=js"
import style0 from "./TableauResultatsPassages.vue?vue&type=style&index=0&id=13f41e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f41e56",
  null
  
)

export default component.exports